import React, { useState, useEffect } from "react";
import ClassNames from "classnames";
import * as s from "./s.module.scss";
import { useTransition, animated } from "react-spring"; // Added import for animation
import WhatsAppicon from "../../images/whatsapp/cropedsvg54x54.svg";

const WhatsAppNumber = "+6531351007";

const WhatsAppFloatingButton = () => {
  const [show, setShow] = useState(true);
  const animationDelay = 150;

  const transitions = useTransition(show, null, {
    from: { opacity: 0, transform: "translateY(-16px) scale(0.96)" },
    enter: { opacity: 1, transform: "translateY(0px) scale(1)" },
    leave: { opacity: 0, transform: "translateY(16px) scale(0.96)" },
    config: { mass: 1, tension: 2000, friction: animationDelay },
  });

  useEffect(() => {
    // Placeholder for any other animations or behaviors on component mount
  }, []);

  return (
    <div ClassNames={s.master_whats}>
      <div className={s.whats_wrapper}>
        {transitions.map(({ item, key, props }) => (
          item && (
            <animated.div key={key} style={props}>
              <div className={s.whats_buttonWrapper}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Chat on WhatsApp"
                  href={`https://wa.me/${WhatsAppNumber}`}
                >
                  <img alt="Chat on WhatsApp" src={WhatsAppicon} />
                </a>
              </div>
            </animated.div>
          )
        ))}
      </div>
    </div>
  );
};

export default WhatsAppFloatingButton;
